import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { isLanguageAvailable } from '../../i18n/languages';

type SettingsState = {
    language: string | null;
    introSeen: boolean;
    setLanguage: (language: string) => void;
    setIntroSeen: (status: boolean) => void;
};

const useSettingsStore = create<SettingsState>()(
    persist(
        (set) => ({
            language: null,
            setLanguage: (language) => set((s) => ({ ...s, language })),
            introSeen: false,
            setIntroSeen: (status) => set((s) => ({ ...s, introSeen: status })),
        }),
        { name: 'SettingsStoreStorage' }
    )
);

const getUsedLocale = () => {
    const customLocale = useSettingsStore.getState().language;

    if (customLocale) {
        return customLocale;
    }

    const browserLanguage = navigator.language?.slice(0, 2)?.toLowerCase();

    if (isLanguageAvailable(browserLanguage)) {
        return browserLanguage;
    }

    return 'sk';
};

export { useSettingsStore, getUsedLocale };
